import React, { useState, useEffect, useCallback } from 'react';
import MatrixBackground from './components/MatrixBackground';
import ResumeContent from './components/ResumeContent';
import LanguageSelector from './components/LanguageSelector';
import en from './locales/en';
import ru from './locales/ru';
import zh from './locales/zh';
import sv from './locales/sv';
import './App.css';

const locales = { en, ru, zh, sv };

const App = () => {
  // Read initial values from URL parameters
  const getInitialParams = () => {
    const params = new URLSearchParams(window.location.search);
    return {
      language: params.get('lang') || 'en',
      theme: params.get('theme') || 'dark'
    };
  };

  const [language, setLanguage] = useState(getInitialParams().language);
  const [theme, setTheme] = useState(getInitialParams().theme);

  // Update URL when settings change
  const updateURL = useCallback((lang, thm) => {
    const params = new URLSearchParams();
    params.set('lang', lang);
    params.set('theme', thm);
    window.history.replaceState({}, '', `?${params.toString()}`);
  }, []);

  // Update URL when language or theme changes
  useEffect(() => {
    updateURL(language, theme);
  }, [language, theme, updateURL]);
  const [fadeIn, setFadeIn] = useState(false);
  const content = locales[language];

  useEffect(() => {
    document.body.className = theme;
    document.documentElement.style.setProperty('--text-color', theme === 'dark' ? '#0f0' : '#000');

    if (theme === 'dark') {
      setFadeIn(false);
      const timer = setTimeout(() => setFadeIn(true), 5000);
      return () => clearTimeout(timer);
    }
  }, [theme]);

  return (
    <div className={`App ${theme} ${fadeIn ? 'fade-in' : ''}`}>
      {theme === 'dark' && <MatrixBackground />}
      {theme === 'light' && (
        <>
          <div className="wave"></div>
          <div className="wave"></div>
          <div className="wave"></div>
        </>
      )}
      <div className="content">
        <LanguageSelector 
          language={language} 
          setLanguage={setLanguage} 
          theme={theme}
          setTheme={setTheme}
          swapOrder={true}
        />
        <ResumeContent content={content} />
        <div className="footer">
          <a href="mailto:dev.it@ryabinin.com" className="contact-link">dev.it@ryabinin.com</a>
        </div>
      </div>
    </div>
  );
};

export default App;
